import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import OverseasreReturnList from '../entities/back-returnrejection-list'
import appconst from '@/lib/appconst';


interface OverseasreReturnListState extends ListState<OverseasreReturnList> {
    OverseasreReturnList: OverseasreReturnList,
}

class BackReturnRejection extends ListMutations<OverseasreReturnList>{

}
class OverseasreReturn extends ListModule<OverseasreReturnListState, any, OverseasreReturnList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OverseasreReturnList>(),
        loading: false,
        id: 0,
        confirmReturnInfo: OverseasreReturnList,
        processFaileInfo: OverseasreReturnList,
        importrejectlistStoreId: Number, 

    }
    actions = {
        async getAll(context: ActionContext<OverseasreReturnListState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackExpressRejectionReturn/GetBackOverseasReturnList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<OverseasreReturnList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async editConfirmRejection(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/ConfirmRejection', payload.data);
        },
        async processFaile(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/processFaile', payload.data);
        },
        async processCancelFaile(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/CancleFail?id=' + payload.data.id);
        },
        async editConfirmReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/ConfirmReturn', payload.data);
        },
        async ConfirmRejectionList(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/ConfirmRejectionList', payload.data);
        },
        async ConfirmDeduction(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/ConfirmDeduction', payload.data);
        },
        async cancleReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/CancleReturn?id=' + payload.data.id);
        },
        async deductionReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/DeductionReturn?id=' + payload.data.id);
        },
        async addWarehouseRemark(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackExpressRejectionReturn/AddWarehouseRemark?id=' + payload.data.id + '&remark=' + payload.data.remark);
        },
        async impotExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetExpressExport', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '拒收待处理.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } 
            });
        },
        async impotOrderExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetOrderExpressExport', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '拒收以及已取消订单待处理.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        },
        async SelectedExportExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetExpressExportSelected', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '选中数据.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        }
    };
    mutations = {
        setCurrentPage(state: OverseasreReturnListState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OverseasreReturnListState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}





const overseasreReturnList = new OverseasreReturn();
export default overseasreReturnList;